function NotFound() {
  return (
    <>
      <h1>404 Not found</h1>
    </>
  );
}

export default NotFound;
